import styled from "styled-components";
import React from "react";
import { Radio } from "semantic-ui-react";
import { connect } from "react-redux";
import { setCurrency } from "../../redux/modules/display-currency";
import { t } from "../../constant/translations";

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
`;

const BGN = "BGN";
const EUR = "EUR";

const RadiobuttonsSwitchCurrency = ({
  selectedCurrency,
  setCurrency,
  fluid,
  className,
}) => {
  const handleChange = (value) => {
    setCurrency(value);
  };

  return (
    <StyledContainer className={className}>
      <span>{t("resources.currency.bgn")}</span>
      <Radio
        toggle
        checked={selectedCurrency === EUR}
        onChange={() => handleChange(selectedCurrency === BGN ? EUR : BGN)}
      />
      <span>{t("resources.currency.eur")}</span>
    </StyledContainer>
  );
};

const mapStateToProps = (state) => ({
  selectedCurrency: state.currency.selectedCurrency,
});

const mapDispatchToProps = {
  setCurrency,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RadiobuttonsSwitchCurrency);
export { RadiobuttonsSwitchCurrency };
